var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1124_7981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8262 14.9883L11.5246 10.6866C12.4677 9.55576 13.0369 8.10274 13.0369 6.51846C13.0369 2.92412 10.1128 0 6.51846 0C2.92412 0 0 2.92412 0 6.51846C0 10.1128 2.92412 13.0369 6.51846 13.0369C8.10274 13.0369 9.55576 12.4677 10.6866 11.5246L14.9883 15.8264C15.104 15.9421 15.2557 16 15.4073 16C15.5588 16 15.7105 15.9421 15.8262 15.8264C16.0578 15.5948 16.0578 15.2197 15.8262 14.9883ZM1.18517 6.51846C1.18517 3.57774 3.57745 1.18517 6.51846 1.18517C9.45947 1.18517 11.8517 3.57774 11.8517 6.51846C11.8517 9.45917 9.45947 11.8517 6.51846 11.8517C3.57745 11.8517 1.18517 9.45917 1.18517 6.51846Z",
    fill: "#8F9EA9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1124_7981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.eeaf42a9d285f089011a92cd9e709ede.svg";
export { ForwardRef as ReactComponent };